import Vue from 'vue'
import Router from 'vue-router'
import store from '../src/store'
import i18n from './i18n'

import Header from './components/Header.vue'
import TermsOfUse from './views/TermsOfUse.vue'
import TermsConditions from './views/TermsConditions.vue'
import Questions from './views/Questions.vue'
import PoolSettings from './views/PoolSettings.vue'
import User from './views/User.vue'
import Profile from './views/Profile.vue'
// import Lab from './views/Lab.vue'
import EULA from './views/EULA.vue'
import Lead from './views/Lead'
import ComingSoon from './views/ComingSoon'
import ContactUs from './views/ContactUs'
import SenseTroubleshooting from './views/SenseTroubleshooting'

Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            beforeEnter () {
                location.href = 'https://faq.waterguru-qa.com'
            },
            meta: {
                title: 'Help'
            },
            components: {
                default: ContactUs,
                header: Header
            },
            props: {
                showMenu: false,
                header: { showMenu: false, showBack: false }
            }
        },
        {
            path: '/coming_soon',
            name: 'coming-soon',
            meta: {
                title: 'ComingSoon'
            },
            components: {
                default: ComingSoon
            }
        },
        {
            path: '/help/sense',
            name: 'help-sense',
            meta: {
                title: 'Help'
            },
            components: {
                default: ContactUs
            }
        },
        {
            path: '/static/legal/terms-of-use',
            name: 'termsOfUse',
            meta: {
                title: 'Website Terms of Use'
            },
            components: {
                default: TermsOfUse
            }
        },
        {
            path: '/terms',
            name: 'termsConditions',
            meta: {
                title: 'Website Terms and Conditions'
            },
            components: {
                default: TermsConditions
            }
        },
        {
            path: '/eula',
            name: 'eula',
            meta: {
                title: 'EULA'
            },
            components: {
                default: EULA
            }
        },
        {
            path: '/user',
            name: 'user',
            props: true,
            meta: {
                title: 'User',
                auth: true
            },
            components: {
                default: User,
                header: Header
            }
        },
        {
            path: '/survey-questions/:pool_id',
            name: 'questions',
            props: true,
            meta: {
                title: 'Questions',
                auth: true
            },
            components: {
                default: Questions
            }
        },
        {
            path: '/profile',
            name: 'profile',
            meta: {
                title: 'Profile',
                auth: true
            },
            components: {
                default: Profile
            }
        },
        {
            path: '/pool-settings/:pool_id',
            name: 'pool-settings',
            meta: {
                title: 'Pool Settings',
                auth: true
            },
            components: {
                default: PoolSettings
            }
        },
        {
            path: '/lab/:pool_id',
            beforeEnter: (to) => {
                const origin = location.origin.replace('webview', 'advice')
                location.href = `${origin}/#/lab-results?wb_id=${to.params.pool_id}`
            }
            // name: 'lab',
            // meta: {
            //     title: 'Lab',
            //     auth: true
            // },
            // props: true,
            // components: {
            //     default: Lab
            // }
        },
        {
            path: '/lead/:step',
            name: 'lead',
            props: true,
            meta: {
                title: 'Lead',
                auth: true
            },
            components: {
                default: Lead
            }
        },
        {
            path: '/SENSE-troubleshooting',
            name: 'SENSE-troubleshooting',
            meta: {
                title: 'SENSE troubleshooting'
            },
            components: {
                default: SenseTroubleshooting
            }
        }
        // {
        //     path: '/not-found',
        //     name: 'not-found',
        //     meta: {
        //         title: 'NotFound'
        //     },
        //     components: {
        //         default: NotFound
        //         // header: Header
        //     }
        // }
    ]
})

router.beforeResolve((to, from, next) => {
    // If this isn't an initial page load.
    if (to.name) store.dispatch('spinner/start')
    next()
})

router.beforeEach((to, from, next) => {
    // If we append &locale= to the query string, we want to store it once
    // (so we don't need to pass it to every subsequent links)
    if (to.query.locale) {
        console.log('URL locale = ' + to.query.locale)
        // NOTE: due to no-console lint (?) option we cannot use
        // console.log('to.query.locale = ' + to.query.locale)
        i18n.locale = to.query.locale
    }

    // If we append &tenant= to the query string, we want to store to the store
    // (so we don't need to pass it to every subsequent links)
    if (to.query.tenant) {
        console.log('URL tenant = ' + to.query.tenant)
        // NOTE: due to no-console lint (?) option we cannot use
        // console.log('to.query.locale = ' + to.query.locale)
        store.commit('tenant/setTenant', to.query.tenant)
        console.log('STORE tenant = ' + store.getters['tenant/tenant'])
    }

    store.dispatch('auth/fetchUser').then(() => next()).catch(() => {
        // if (to.meta.auth) next({ name: 'not-found' })
        // else
        next()
    })
})

export default router
